import { apiRequest, clearGetCache } from './api';

function getAuthHeaders() {
  try {
    const token = window.localStorage.getItem('chse_auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export async function updateLessonProgress(lessonId, payload) {
  const response = await apiRequest(`/api/lessons/${lessonId}/progress`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  clearGetCache(`/api/lessons/${lessonId}/progress`);
  return response;
}
